var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLogoBrandCompetition = function SvgLogoBrandCompetition(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 167.4,
    height: 55.1,
    viewBox: "0 0 167.4 55.1",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 167.4,
    height: 55,
    style: {
      fill: "none",
      strokeWidth: 0
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#b)"
    }
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M71.9,31.7c0,1.7,1,2.5,2.7,2.5.8,0,1.6-.2,2.3-.5h.2c0-.1.1-.2.2-.2.1,0,.2.1.2.3v1.6c0,.7-1.6,1.1-3.7,1.1-3.3,0-4.9-1.5-4.9-4.7s.8-4.5,2.3-5.9c.5-.5,1-.8,1.7-1.1.6-.2,1.3-.4,2-.3,2.1,0,3.3,1,3.3,2.8,0,2.7-2.3,4.2-6.2,4.3ZM72,29.6c2.3-.1,3.5-.8,3.5-2s-.4-1-1.1-1c-1.3,0-2.2,1.1-2.4,2.9h0Z",
    style: {
      fill: "#dd3015",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.1,35.6l-1.2.8c0,0-.2.1-.3.1-.2,0-.3-.1-.3-.4h0c0-.1.8-15,.8-15,0-.2.1-.4.4-.4h2.2c.3,0,.4,0,.4.3l-.4,8.2c.9-3.1,2.5-4.8,4.5-4.8s2.8,1.4,2.8,3.9-.8,4.7-2.1,6.3c-.5.5-1,1-1.7,1.3-.7.3-1.4.4-2.1.4-1.1,0-2.2-.3-3.1-.9ZM82.2,34.2c.4.2.9.3,1.4.3,2.2,0,3.4-1.9,3.4-5.4s-.2-1.4-.7-1.4h0c-.3,0-.5.1-.7.3-.7.8-1.3,1.7-1.8,2.7-.6,1.1-1.1,2.3-1.5,3.6h0Z",
    style: {
      fill: "#dd3015",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7,31.7c0,1.7,1,2.5,2.7,2.5.8,0,1.6-.2,2.3-.5h.2c0-.1.1-.2.2-.2.1,0,.2.1.2.3v1.6c0,.7-1.6,1.1-3.7,1.1-3.3,0-4.9-1.5-4.9-4.7s.8-4.5,2.3-5.9c.5-.5,1-.8,1.7-1.1.6-.2,1.3-.4,2-.3,2.1,0,3.3,1,3.3,2.8,0,2.7-2.3,4.2-6.3,4.3ZM93.8,29.6c2.3-.1,3.5-.8,3.5-2s-.4-1-1.1-1c-1.3,0-2.2,1.1-2.4,2.9h0Z",
    style: {
      fill: "#dd3015",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.5,29.7c1.1-3.5,2.6-5.2,4.6-5.2s2.3.8,2.3,2.5v.3l-.5,8.5c0,.3-.1.4-.4.4h-2.3c-.3,0-.4,0-.4-.4h0s.3-7,.3-7c0-.1,0-.2,0-.3,0-.5-.2-.7-.5-.7s-1,.6-1.7,1.7c-.6,1-1,2.1-1.4,3.1-.1.5-.2,1-.2,1.5v1.6c0,.3-.2.4-.5.4h-2.2c-.3,0-.4,0-.4-.4h0c0,0,.6-10.7.6-10.7,0-.3.1-.4.4-.4h2.2c.3,0,.4,0,.4.3h0c0,0-.2,4.6-.2,4.6Z",
    style: {
      fill: "#dd3015",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.5,35.4v-1.8c0-.2.2-.3.4-.3.1,0,.2,0,.3.1.9.5,1.9.8,2.9.8.9,0,1.4-.3,1.4-.9s-.1-.5-.7-.8l-2-1.2c-1.2-.7-1.7-1.6-1.7-2.9,0-2.4,1.6-3.9,4.1-3.9s3.1.5,3.1,1h0s0,1.6,0,1.6c0,.2-.1.4-.3.4s-.2,0-.6-.3c-.6-.4-1.3-.5-2.1-.6-.9,0-1.5.4-1.5,1,0,.1,0,.3.1.4,0,.1.2.2.3.3l2.2,1.4c1.2.7,1.7,1.6,1.7,2.9,0,2.3-1.7,3.8-4.3,3.8s-3.4-.4-3.4-1h0Z",
    style: {
      fill: "#ecdf0f",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.8,27.2v.3c-.1,0-.4,1.1-.4,1.1l-.3,1.3-.3,1.2-1.3,4.1c-.3,1.1-.4,1.1-1,1.1h-2.3c-.5,0-.7-.2-.8-1.1l-2.1-10h0c0-.2.1-.3.3-.3h2.6c.2,0,.3,0,.3.2l.6,4c0,.4.1.9.2,1.8,0,.7.1,1.1.1,1.4v.9c0,0,0,.5,0,.5,0-.2,0-.3,0-.4,0,0,.1-.5.3-1.1l.4-1.4,1.6-5.5c0-.3.3-.5.5-.5h2.9c.1,0,.2,0,.3.1,0,0,.2.2.2.3l.5,4.4v1.4c.1,0,.3,1.3.3,1.3,0,.5,0,.7.1,1.2v-.3c.1-.2.2-.6.4-1,.4-1.3.6-2.2.8-2.8l1.4-4.4c0-.2.2-.3.4-.3h2.2c.2,0,.3,0,.3.2h0c0,.1-3.9,10.3-3.9,10.3-.3.8-.4.9-.9.9h-2.3c-.6,0-.7-.2-.8-1.2l-.2-2.4c0-.2,0-.9-.2-1.9,0-.9-.1-1.5-.1-1.8v-1.3s0-.5,0-.5Z",
    style: {
      fill: "#0089c1",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141,31.7c0,1.7,1,2.5,2.7,2.5.8,0,1.6-.2,2.3-.5h.2c0-.1.1-.2.2-.2.1,0,.2.1.2.3v1.6c0,.7-1.6,1.1-3.7,1.1-3.3,0-4.9-1.5-4.9-4.7s.8-4.5,2.3-5.9c.5-.5,1.1-.8,1.7-1.1.6-.2,1.3-.4,2-.3,2.1,0,3.3,1,3.3,2.8,0,2.7-2.3,4.2-6.3,4.3ZM141.1,29.6c2.3-.1,3.5-.8,3.5-2s-.4-1-1.1-1c-1.3,0-2.2,1.1-2.4,2.9h0Z",
    style: {
      fill: "#0089c1",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.8,29.7c.1-1,.4-1.9.9-2.8.2-.5.5-.9.9-1.3.3-.3.6-.6,1-.8.4-.2.8-.3,1.2-.3.9,0,1.2.2,1.2.7v2.3c-.1.3-.3.4-.5.4-.1,0-.3,0-.4-.1-.3-.1-.6-.2-.9-.2-1.1,0-1.8.9-2.9,3.3-.5,1.1-.8,2.2-.9,3.4v1.6c0,.3-.2.4-.5.4h-2.2c-.3,0-.4,0-.4-.4h0c0,0,.6-10.7.6-10.7,0-.3.1-.4.4-.4h2.2c.3,0,.4,0,.4.3h0c0,0-.2,4.6-.2,4.6Z",
    style: {
      fill: "#0089c1",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.8,27h-1.1c-.3,0-.4-.1-.4-.4h0s0-1.4,0-1.4c0-.3.1-.4.4-.4h1.1v-2.2c.1-.3.2-.4.5-.4h2.2c.3,0,.4,0,.4.4h0c0,0-.1,2.3-.1,2.3h3.4c.3,0,.4,0,.4.3h0s0,1.5,0,1.5c0,.3-.1.4-.4.4h-3.4l-.3,5.4v.2c0,1,.5,1.6,1.5,1.6.5,0,1.1-.1,1.6-.3h.2c0-.1.1-.2.2-.1.2,0,.2,0,.2.3v1.3c0,.6-1.6,1.1-3.4,1.1s-3.4-.9-3.4-2.8c0,0,0-.1,0-.2l.3-6.5Z",
    style: {
      fill: "#0089c1",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9,26.3h.7c.1,0,.2,0,.2.1s0,0-.1.2c-.8,1.2-1.3,3.3-1.3,5.6s.3,3.1.8,4c0,.1,0,.2,0,.2,0,0,0,0,0,0,0,0,0,0-.1,0h-.8c-.2,0-.3-.2-.7-.8-.5-1.1-.8-2.4-.8-3.6,0-.9,0-1.8.3-2.6.2-.9.6-1.7,1-2.5.4-.7.5-.8.7-.8Z",
    style: {
      fill: "#009f6b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8,27c.5.8.8,1.6,1,2.5.2.9.3,1.7.3,2.6,0,1.2-.3,2.5-.8,3.6-.3.7-.4.8-.7.8h-.8c0,0-.2,0-.2-.1s0,0,0-.2c.5-.9.8-2.3.8-4s-.5-4.4-1.3-5.6c0-.1-.1-.2-.1-.2s0-.1.2-.1h.7c.2,0,.3.1.7.8Z",
    style: {
      fill: "#009f6b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.6,25.4c1.4,0,2.6-1.1,2.6-2.6s-1.1-2.6-2.6-2.6-2.6,1.1-2.6,2.6,1.1,2.6,2.6,2.6Z",
    style: {
      fill: "#009f6b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8,28c0-.5-.1-.9-.4-1.3-.5.5-1.1.7-1.8.7-.7,0-1.3-.3-1.8-.7h0c-.3.3-.5.8-.5,1.3,0,2.2-.1,7.9-.2,9,0,.7.3,1.3.7,1.8.5.5,1.1.7,1.8.7s1.3-.3,1.8-.7c.5-.5.7-1.1.7-1.8,0-1-.4-6.7-.4-9Z",
    style: {
      fill: "#009f6b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9,36.2l.8-14.7c0-.3.1-.4.4-.4h2.2c.3,0,.4.1.4.4h0s-.8,14.8-.8,14.8c0,.3-.1.4-.4.4h-2.2c-.3,0-.4-.1-.4-.4h0Z",
    style: {
      fill: "#dd3015",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,39.4c0-1.2.4-2.3,1.3-3.1-.2-.6-.7-1-1.3-1.3l-6.8-2.9,4-.2c.5,0,1-.2,1.3-.6-.4-1-.4-2.2,0-3.2-.2-.2-.4-.3-.7-.4-.3,0-.5-.1-.8-.1l-3.5.2,6.4-4.9c.4-.3.8-.8,1-1.3.2-.5.3-1.1.1-1.7-.9-.6-1.6-1.4-2-2.3-.5-.2-1-.2-1.5-.1-.5,0-1,.3-1.4.6l-6.3,4.9,2-5.8c.2-.5.2-1,0-1.5h-.3c-1.1,0-2.1-.4-2.9-1.1-.4.3-.8.7-.9,1.2l-1.1,3.1v-6.8c0-.4-.1-.9-.3-1.3-.2-.4-.5-.7-.9-1-1,.3-2.1.4-3.1,0-.4.2-.7.6-.9,1-.2.4-.3.8-.3,1.3v7.2l-2.3-4.6c-.1-.3-.3-.5-.6-.7-.2-.2-.5-.3-.8-.3-.6.5-1.3.8-2,1-.1.3-.2.6-.2.9,0,.3,0,.6.2.9l4.2,8.5-2.4-1.8c-.3-.2-.7-.4-1-.4-.2,1-.8,1.8-1.6,2.4.1.3.3.5.5.7l3.1,2.4-3.8-.2c-.4,0-.7,0-1,.2.2.5.3,1,.3,1.6,0,.5-.2,1.1-.4,1.6.3.2.6.3,1,.3l4.9.3-2.5,2.6c-.3.3-.4.6-.6.9-.1.3-.2.7-.1,1.1,1.1.5,1.9,1.3,2.4,2.3.4,0,.7,0,1.1-.2.3-.1.7-.3.9-.6l2.2-2.3v5.4c0,.4.2.9.4,1.2.9-.4,2-.4,2.9,0,.3-.3.4-.8.4-1.2v-2.8l.6,1c.2.3.4.5.6.7.3.2.5.3.8.3.5-.9,1.4-1.6,2.4-1.9,0-.4,0-.8-.3-1.2l-.8-1.3,8.4,3.6c.3.1.7.2,1,.2s.7,0,1-.2c0,0,0,0,0-.2Z",
    style: {
      fill: "#a6cee8",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5,30.9c-.2.7-.7,1.5-1.6,1.7-.5.1-.9.2-1.4.2v-1.1c.5,0,1.1,0,1.5-.5.2-.3.4-.7.4-1.1h0c0-.4.1-.7.2-1h0c.2-1.6.3-3.2,2-3.5.5,0,.9,0,1.4,0v1.1c-.5,0-1,0-1.5.3-.3.3-.4.6-.5,1l-.2,1.1h0s-.3,1.8-.3,1.8h0Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3,25.5c-.7,0-1.4.2-1.9.7-.5.5-.8,1.2-.8,1.9v4.6h1.2v-3.9l.4,1.7c.3.1.7.2,1.1.2.7,0,1.3-.3,1.8-.7s.8-1.1.8-1.7c0-.7-.2-1.3-.6-1.8-.4-.5-1-.8-1.7-.9h-.3ZM22.3,29.5c-.3,0-.5-.1-.8-.3-.2-.2-.4-.4-.5-.7,0-.3-.1-.5,0-.8,0-.3.2-.5.4-.7.2-.2.5-.3.7-.4.3,0,.6,0,.8,0,.3.1.5.3.6.5.2.2.2.5.2.8,0,.4-.2.8-.5,1-.3.3-.7.4-1,.4h0Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6,25.5v3.9l-.4-1.7c-.3-.1-.7-.2-1.1-.2-.5,0-1,.2-1.4.5-.4.3-.7.7-.9,1.2-.2.5-.2,1,0,1.5.1.5.4.9.7,1.3.4.4.8.6,1.3.7.5,0,1,0,1.5-.2.5-.2.9-.5,1.2-1,.3-.4.4-.9.4-1.4v-4.6h-1.2ZM30.1,31.5c-.3,0-.5-.1-.8-.3-.2-.2-.4-.4-.5-.7,0-.3-.1-.5,0-.8,0-.3.2-.5.4-.7.2-.2.5-.3.7-.4s.6,0,.8,0c.3.1.5.3.6.5.2.2.2.5.2.8,0,.4-.2.8-.5,1-.3.3-.7.4-1,.4h0Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8,15.8l-.6.6c-.1.1-.2.2-.4.3-.1,0-.3.1-.4.2-.1,0-.3,0-.4,0-.2,0-.3-.1-.4-.2-.1-.1-.2-.2-.3-.4,0-.1,0-.3,0-.4,0-.1,0-.3.1-.4,0-.1.2-.2.3-.3l.3-.3-1-.9.3-.4,2.4,2.2ZM9.4,15.1l-.3.3c0,0,0,.1-.1.2,0,0,0,.1,0,.2,0,0,0,.2,0,.2,0,0,0,.2.2.2,0,0,.1.1.2.1,0,0,.2,0,.2,0,0,0,.2,0,.2-.1,0,0,.1,0,.2-.2l.3-.3-.8-.8Z",
    style: {
      fill: "#009f6b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9,18.5h.1c0,0,.1-.2.1-.2,0,0,0,0,.1,0,0,0,0,0,0-.1,0,0,0-.1,0-.2,0,0,0-.1,0-.2,0,0,0-.1,0-.2,0,0,0-.1-.1-.2,0,0,0,0-.1,0,0,0,0,0-.1,0-.1,0-.2,0-.3,0-.1,0-.2.1-.3.2-.1,0-.2.1-.4.2-.1,0-.3,0-.4,0-.1,0-.3,0-.4-.2-.1,0-.2-.2-.3-.3,0-.1,0-.3,0-.4,0-.1,0-.3,0-.4,0-.1.1-.3.2-.4,0,0,.1-.2.2-.2,0,0,.2-.1.3-.2l.3.3h-.1c0,.1,0,.1-.1.2,0,0,0,0-.1.1,0,0,0,0-.1.1,0,0,0,.1,0,.2,0,0,0,.1,0,.2,0,0,0,.2,0,.2,0,0,0,.1.2.2,0,0,0,0,.1,0,0,0,.1,0,.2,0,.1,0,.2,0,.3,0,.1,0,.2-.1.3-.2.1,0,.2-.1.4-.2.1,0,.2,0,.4,0,.1,0,.3,0,.4.2.1,0,.2.2.3.3,0,.1,0,.2,0,.3,0,.1,0,.2,0,.4,0,.1-.1.3-.2.4,0,0-.1.2-.2.3,0,0-.2.2-.3.2l-.3-.3Z",
    style: {
      fill: "#009f6b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,19.4l-.5.8c-.1.2-.2.4-.4.5-.2.1-.3.3-.5.3-.2,0-.4.1-.6,0-.2,0-.5,0-.7-.2-.2-.1-.4-.3-.6-.4-.1-.2-.2-.3-.3-.5,0-.2,0-.4,0-.6,0-.2.1-.5.3-.7l.5-.8,2.8,1.5ZM5.2,18.4l-.2.4c-.2.3-.2.6-.2,1,0,.2.1.3.3.4.1.1.3.2.4.3.2,0,.3.1.5.2.2,0,.3,0,.5,0,.1,0,.3-.1.4-.2.1-.1.2-.2.3-.4l.3-.5-2.2-1.2Z",
    style: {
      fill: "#009f6b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.1,23.3l-.2.8c0,.2,0,.3-.2.4,0,.1-.1.2-.2.3,0,0-.2.1-.3.2-.1,0-.3,0-.4,0,0,0-.2,0-.3-.1,0,0-.1-.1-.2-.2,0-.2-.1-.4-.1-.5,0,0,0,.2-.2.3,0,0-.1.1-.2.2,0,0-.2,0-.3,0-.1,0-.2,0-.3,0-.2,0-.3-.1-.4-.2,0,0-.2-.2-.2-.3,0-.1,0-.3,0-.4,0-.2,0-.3.1-.5l.2-.8,3.1.9ZM3.2,23v.3c-.1,0-.2.2-.2.3,0,0,0,.2,0,.3,0,0,0,.2.1.2,0,0,.1.1.2.1.1,0,.2,0,.3,0,0,0,.2,0,.2-.1,0,0,.1-.2.2-.2,0,0,0-.2.1-.3v-.3c0,0-1-.3-1-.3ZM4.6,23.4v.2c-.1.1-.1.2-.1.3,0,0,0,.2,0,.3,0,0,0,.2,0,.2,0,0,.2.1.3.1,0,0,.2,0,.2,0,0,0,.1,0,.2,0,0,0,0-.1.1-.2,0,0,0-.1,0-.2v-.4c.1,0-.8-.3-.8-.3Z",
    style: {
      fill: "#009f6b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.3,25.8c0,.1,0,.3.1.4,0,.1,0,.3,0,.4,0,.1,0,.3-.1.4,0,.1-.1.2-.2.3-.2.1-.5.2-.8.1l-1-.2h-.3c0,0-.2,0-.2,0v-.4c0,0,.4,0,.4,0,0,0,0,0,0-.1,0,0,0-.1,0-.2,0,0,0-.2,0-.2,0,0,0-.2,0-.3,0-.1,0-.2,0-.3,0,0,.1-.2.2-.3,0,0,.2-.1.3-.1.1,0,.2,0,.3,0,.1,0,.3,0,.4.2,0,0,.2.2.2.3,0,.1,0,.2,0,.4,0,.1,0,.2,0,.4v.2c0,0,0,.2,0,.2.2,0,.3,0,.5,0,0,0,.1-.1.2-.2s0-.2,0-.2c0-.2,0-.5-.1-.7h.4ZM3.1,26.9s0,0,0-.1c0,0,0,0,0-.1,0,0,0-.1,0-.2,0,0,0-.2,0-.3,0,0,0-.2,0-.3,0,0,0,0-.1,0,0,0,0,0-.1,0,0,0-.1,0-.2,0,0,0,0,0-.1,0,0,0,0,0,0,.1,0,0,0,0,0,.1,0,0,0,.2,0,.3,0,0,0,.2.1.2,0,.1.2.2.4.2h.2Z",
    style: {
      fill: "#009f6b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2,28.3v.4h-.4c.1,0,.2.2.3.3,0,.1.1.3.1.5,0,.1,0,.3,0,.4s-.1.2-.2.3c-.2.1-.5.2-.8.2h-1.4v-.5h1.2c.2,0,.4,0,.6,0,0,0,.1,0,.2-.2,0,0,0-.1,0-.2,0-.1,0-.2,0-.3,0,0,0-.2-.2-.2,0,0-.2-.1-.3-.1-.1,0-.3,0-.4,0h-1.1v-.5h2.4Z",
    style: {
      fill: "#009f6b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.3,30.9v.4s-2,.2-2,.2l1.1.8v.6c0,0-1.1-1-1.1-1l-1.2,1.4v-.6c0,0,1-1.2,1-1.2h-1.2c0,.1,0-.3,0-.3l3.5-.4Z",
    style: {
      fill: "#009f6b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6,34.6l.2.8c0,.2,0,.3.1.5,0,.1,0,.3,0,.4,0,.1,0,.3-.2.4-.1.1-.2.2-.4.2,0,0-.2,0-.3,0,0,0-.2,0-.3,0-.2,0-.3-.2-.4-.4,0,0,0,.1,0,.2,0,0-.1.1-.2.2l-1.1,1-.2-.5.9-.8c0,0,0-.1.1-.2,0,0,0,0,0-.1,0,0,0,0,0-.1,0,0,0-.1,0-.2v-.3c0,0-1.4.4-1.4.4v-.4c-.1,0,2.9-.9,2.9-.9ZM4.4,35.4v.4c.2.2.3.3.4.5,0,0,.1,0,.2,0,0,0,.1,0,.2,0,0,0,.1,0,.2,0,0,0,0-.1.1-.2,0-.2,0-.3,0-.5v-.4c-.1,0-1.1.3-1.1.3Z",
    style: {
      fill: "#009f6b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6,37l.2.4-1.3.6c.1,0,.3,0,.4.2.1,0,.2.2.3.4,0,.1,0,.2.1.4,0,.1,0,.3,0,.4-.1.2-.3.4-.6.5l-1.3.6-.2-.4,1.1-.5c.2,0,.4-.2.5-.4,0,0,0-.1,0-.2,0,0,0-.2,0-.2,0-.1-.1-.2-.2-.3,0,0-.2-.1-.3-.1-.1,0-.2,0-.3,0-.1,0-.3,0-.4.1l-1,.5-.2-.4,3.2-1.5Z",
    style: {
      fill: "#009f6b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8,42.7h-.1c0,0-.1-.2-.1-.2,0,0,0,0-.1-.1,0,0-.1-.1-.2-.2-.1-.2-.2-.3-.2-.5,0-.2,0-.3,0-.5,0-.1.1-.3.2-.4.1-.1.2-.3.4-.3.1,0,.3-.2.5-.2.1,0,.3,0,.4,0,.1,0,.3,0,.4.2.1,0,.2.2.3.3,0,.1.2.3.2.5,0,.1,0,.3,0,.4,0,.1-.2.3-.3.4-.1.1-.3.2-.4.3l-.9-1.4c0,0-.2.1-.2.2,0,0-.1.2-.1.3,0,0,0,.2,0,.3,0,.1,0,.2.1.3,0,0,0,.1.1.2,0,0,.1.1.2.1,0,0,.1,0,.2.1h.1c0,0-.4.3-.4.3ZM6.8,41.8c0,0,.1-.1.2-.2,0,0,0-.1.1-.2,0,0,0-.2,0-.2,0,0,0-.2,0-.2,0,0-.1-.2-.2-.2,0,0-.2,0-.2,0,0,0-.2,0-.2,0,0,0-.2,0-.2,0l.7,1.1Z",
    style: {
      fill: "#009f6b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2,42.2l.3.4-1.9,1.4-.3-.3,1.9-1.4ZM8.9,42.2l-.3-.4.4-.3.3.4-.4.3Z",
    style: {
      fill: "#009f6b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.9,43.1l.3.3-.3.3c.1,0,.3,0,.4,0,.2,0,.3.1.4.3,0,0,.2.2.2.3,0,.1,0,.2,0,.4,0,.3-.2.5-.4.7l-1,.9-.3-.3.9-.8c.2-.1.3-.3.4-.5,0,0,0-.2,0-.2,0,0,0-.1-.1-.2,0,0-.2-.2-.3-.2,0,0-.2,0-.3,0-.1,0-.2,0-.3.1-.1,0-.2.1-.3.2l-.8.7-.3-.3,1.7-1.6Z",
    style: {
      fill: "#009f6b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4,44.5l.5.4-.5,3,1.6-2,.4.3-2,2.5-.5-.4.5-3-1.7,2.1-.4-.3,2-2.5Z",
    style: {
      fill: "#009f6b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9,50h-.1s-.2,0-.2,0h-.2c0-.1-.2-.1-.2-.2-.2,0-.3-.2-.4-.4,0-.1-.2-.3-.2-.4,0-.2,0-.3,0-.5,0-.2.1-.3.2-.5,0-.1.2-.3.3-.4.1,0,.3-.2.4-.2.1,0,.3,0,.4,0,.2,0,.3,0,.4.2.2,0,.3.2.4.3,0,.1.1.3.1.4,0,.2,0,.3,0,.5,0,.2-.1.3-.2.5l-1.5-.9c0,0,0,.2-.1.3,0,.1,0,.2,0,.3,0,0,0,.2.1.3,0,0,.1.2.2.2,0,0,.1,0,.2,0h.2c0,0,.1,0,.2,0h.1l-.3.4ZM14.3,48.8c0,0,0-.2,0-.2,0,0,0-.2,0-.2,0,0,0-.2,0-.2,0,0-.1-.1-.2-.2,0,0-.2,0-.3,0,0,0-.2,0-.2,0,0,0-.1,0-.2.1,0,0-.1.1-.2.2l1.1.6Z",
    style: {
      fill: "#009f6b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9,49.4c0,0-.1-.1-.2-.2,0,0-.1,0-.2-.1,0,0-.2,0-.3,0s-.2,0-.3,0c0,0-.2.1-.3.2,0,0-.1.2-.2.3,0,0,0,.2,0,.3,0,.1,0,.2,0,.3,0,.1,0,.2.1.3,0,0,.2.2.3.2,0,0,.2,0,.2,0,0,0,.2,0,.3,0v.4c-.2,0-.3,0-.4,0,0,0-.2,0-.3,0-.2,0-.3-.2-.4-.3-.1-.1-.2-.3-.2-.4,0-.1,0-.3,0-.5,0-.2,0-.3.1-.5,0-.2.2-.3.3-.4.1-.1.2-.2.4-.3.1,0,.3,0,.5,0,.2,0,.3,0,.5.1,0,0,.2,0,.3.1,0,0,.1,0,.2.2l-.2.3Z",
    style: {
      fill: "#009f6b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9,48.1h.4c0,.1-.6,2.1-.6,2.1l1.2-.6.6.2-1.4.7.8,1.6-.6-.2-.6-1.5-.4,1.2h-.4c0-.1,1.1-3.5,1.1-3.5Z",
    style: {
      fill: "#009f6b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,50.1c.1,0,.3,0,.4,0,.1,0,.3,0,.4,0,.1,0,.3,0,.4.1.1,0,.2.2.3.3.1.2.1.5,0,.8l-.2,1c0,.1,0,.2,0,.3,0,0,0,.1,0,.2h-.4c0,0,0-.4,0-.4,0,0,0,0-.1,0,0,0-.1,0-.2,0,0,0-.1,0-.2,0,0,0-.2,0-.3,0-.1,0-.2,0-.3-.1,0,0-.2-.1-.2-.2,0,0-.1-.2-.1-.3,0-.1,0-.2,0-.3,0-.1,0-.3.2-.3,0,0,.2-.1.3-.2.1,0,.3,0,.4,0,.1,0,.2,0,.4,0h.2s.2,0,.2,0c0-.2,0-.3,0-.5,0,0-.1-.1-.2-.2,0,0-.2,0-.2,0-.1,0-.3,0-.4,0-.1,0-.2,0-.3.1v-.4ZM21.1,51.4h-.1s-.1,0-.1,0h-.2c0,0-.2,0-.3,0,0,0-.2,0-.3,0,0,0,0,0,0,0,0,0,0,0,0,.1,0,0,0,.1,0,.2,0,0,0,0,0,.1,0,0,0,0,.1,0,0,0,0,0,.1,0,0,0,.2,0,.3,0,0,0,.2,0,.3,0,.1,0,.2-.2.2-.4v-.2Z",
    style: {
      fill: "#009f6b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,50.4h.4s0,.4,0,.4c0-.1.2-.2.3-.3.1,0,.2,0,.4,0,0,0,.1,0,.2,0h.1s0,.4,0,.4c0,0,0,0-.1,0h-.1c0,0-.2,0-.3,0,0,0-.2,0-.2.2-.1.2-.2.4-.2.7v1c0,0-.5,0-.5,0l.2-2.4Z",
    style: {
      fill: "#009f6b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8,50.1h-.2c0,0-.1,0-.1,0,0,0,0,0-.1,0h-.2c0,0-.1,0-.2,0,0,0-.1,0-.2,0,0,0-.1,0-.1.1,0,0,0,.1,0,.2,0,0,0,0,0,.1,0,0,0,0,0,.1,0,0,.2.1.3.2.1,0,.2.1.3.2.1,0,.2.1.3.2.1,0,.2.2.3.3,0,.1.1.3.1.4,0,.2,0,.3,0,.4,0,.1-.1.2-.3.3-.1,0-.3.1-.4.2-.2,0-.3,0-.5,0-.1,0-.2,0-.3,0h-.3c0,0,0-.5,0-.5h.1s.2,0,.2,0h.2s.2,0,.2,0c0,0,.1,0,.2,0,0,0,.1,0,.2,0,0,0,.1,0,.2-.2,0,0,0-.2,0-.3,0,0,0-.1,0-.2,0,0,0,0,0-.1,0,0-.2-.1-.3-.2-.1,0-.2-.1-.3-.2-.1,0-.2-.1-.3-.2-.1,0-.2-.2-.3-.3,0-.1-.1-.3-.1-.4,0-.1,0-.3,0-.4,0-.1.1-.2.2-.3,0,0,.2-.1.3-.2.1,0,.3,0,.4,0,.1,0,.2,0,.3,0,.1,0,.2,0,.4,0v.4Z",
    style: {
      fill: "#009f6b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6,50.6c.1,0,.2-.2.3-.2.1,0,.3,0,.4-.1.1,0,.3,0,.4,0,.1,0,.3,0,.4.2.2.2.3.4.3.7v1c.1.1.1.2.2.3,0,0,0,.1,0,.2h-.4c0,0,0-.3,0-.3,0,0,0,0,0,.1,0,0,0,0-.1.1,0,0-.1,0-.2.1,0,0-.2,0-.3,0-.1,0-.2,0-.4,0-.1,0-.2,0-.3,0,0,0-.2-.1-.2-.2,0,0,0-.2-.1-.3,0-.1,0-.3,0-.4,0-.1.1-.2.2-.3.1,0,.2-.1.3-.2.1,0,.2,0,.4,0h.2s.2,0,.2,0c0-.2,0-.3-.2-.4,0,0-.1,0-.2-.1,0,0-.2,0-.2,0-.1,0-.2,0-.4.1-.1,0-.2.1-.3.2v-.3ZM28.1,51.5h-.5c0,0-.2,0-.3.1,0,0-.2,0-.2.2,0,0,0,0,0,.1,0,0,0,0,0,.1,0,0,0,.1,0,.2,0,0,0,0,.1.1,0,0,0,0,.2,0,0,0,.1,0,.2,0,0,0,.2,0,.3,0,0,0,.2,0,.2-.2,0-.1.1-.3.1-.5v-.2Z",
    style: {
      fill: "#009f6b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2,50.2c0,0,.2-.2.3-.2.1,0,.3-.1.4-.2.1,0,.3,0,.4,0,.1,0,.3,0,.4.1.2.2.4.4.4.7l.2,1c0,.1,0,.2,0,.3,0,0,0,0,0,.1h-.4c0,0,0-.2,0-.2,0,0,0,0,0,.1,0,0,0,.1-.1.2,0,0-.1,0-.2.1,0,0-.2,0-.3.1-.1,0-.2,0-.4,0-.1,0-.2,0-.3,0,0,0-.2-.1-.2-.2,0,0-.1-.2-.1-.3,0-.1,0-.3,0-.4,0-.1.1-.2.2-.3,0,0,.2-.2.3-.2.1,0,.2,0,.3-.1h.2c0,0,.2-.1.2-.1,0-.2-.1-.3-.2-.4,0,0-.2,0-.2,0,0,0-.2,0-.2,0-.1,0-.2,0-.3.2-.1,0-.2.2-.3.3v-.4ZM30.7,50.9h-.1s-.1,0-.1,0h-.2c0,0-.2.1-.3.2,0,0-.1.1-.2.2,0,0,0,0,0,.1,0,0,0,0,0,.1,0,0,0,.1,0,.2,0,0,.2.1.3.1,0,0,.1,0,.2,0,0,0,.2,0,.2-.1,0,0,.1-.1.2-.2,0-.1,0-.3,0-.5v-.2Z",
    style: {
      fill: "#009f6b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5,49.4h.4c0-.1.1.2.1.2,0-.1,0-.3.1-.4,0-.1.2-.2.3-.2,0,0,0,0,.2,0h.1s.1.3.1.3c0,0,0,0-.1,0h-.1c0,0-.2.1-.2.2s-.1.2-.1.2c0,.2,0,.5,0,.7l.4,1-.4.2-.9-2.2Z",
    style: {
      fill: "#009f6b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,49.2h0c0,.1-.1.2-.1.2h-.2c0,.2-.1.2-.2.3-.2,0-.3.2-.5.2-.2,0-.3,0-.5,0-.1,0-.3-.1-.4-.2-.1-.1-.2-.3-.3-.4,0-.1-.1-.3-.2-.5,0-.1,0-.3,0-.4,0-.1,0-.3.2-.4,0-.1.2-.2.4-.3.1,0,.3-.1.5-.2.1,0,.3,0,.4,0,.1,0,.3.2.4.3.1.1.2.3.3.4l-1.5.8c0,0,.1.2.2.2,0,0,.2.1.3.1.1,0,.2,0,.3,0,.1,0,.2,0,.3-.1,0,0,.1,0,.2-.1,0,0,.1-.1.2-.2,0,0,0-.1.1-.2,0,0,0,0,0-.1l.2.4ZM36.1,48.2c0,0,0-.1-.2-.2,0,0-.1,0-.2-.1,0,0-.2,0-.2,0,0,0-.2,0-.2,0,0,0-.2.1-.2.2,0,0,0,.1,0,.2,0,0,0,.2,0,.2,0,0,0,.2,0,.2l1.1-.6Z",
    style: {
      fill: "#009f6b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2,45.1c-.1,0-.3,0-.4,0-.2,0-.3.2-.4.3-.1.1-.3.2-.3.4,0,.1-.1.3-.1.5,0,.2,0,.3,0,.5.1.3.3.6.6.8.1,0,.3.1.5.2.2,0,.3,0,.5,0,.2,0,.3-.1.4-.2h.2c0-.1,0-.2,0-.2h0c0,0,0-.1,0-.1l-.6-.8-.5.4-.2-.3.9-.7,1,1.3c0,.1-.2.2-.2.3-.1.2-.3.3-.5.5-.2.1-.4.3-.6.3-.2,0-.4,0-.6,0-.2,0-.4,0-.6-.2-.2-.1-.4-.3-.5-.5-.1-.2-.3-.4-.3-.6,0-.2,0-.4,0-.6,0-.2.1-.4.2-.6.1-.2.3-.4.5-.5,0,0,.2-.1.3-.2,0,0,.1,0,.2-.1h.2c0,0,.2-.2.2-.2l.3.4Z",
    style: {
      fill: "#009f6b",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8,7.8c1.5,0,2.7-1.2,2.7-2.7s-1.2-2.7-2.7-2.7-2.7,1.2-2.7,2.7,1.2,2.7,2.7,2.7Z",
    style: {
      fill: "#a6cee8",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8,12.5c1.1,0,2-.9,2-2s-.9-2-2-2-2,.9-2,2,.9,2,2,2Z",
    style: {
      fill: "#a6cee8",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5,13.4c1.3,0,2.3-1,2.3-2.3s-1-2.3-2.3-2.3-2.3,1-2.3,2.3,1,2.3,2.3,2.3Z",
    style: {
      fill: "#a6cee8",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9,18.6c1.7,0,3.1-1.4,3.1-3.1s-1.4-3.1-3.1-3.1-3.1,1.4-3.1,3.1,1.4,3.1,3.1,3.1Z",
    style: {
      fill: "#a6cee8",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.5,31.9c1.2,0,2.1-1,2.1-2.1s-1-2.1-2.1-2.1-2.1,1-2.1,2.1,1,2.1,2.1,2.1Z",
    style: {
      fill: "#a6cee8",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.6,41.9c1.3,0,2.4-1.1,2.4-2.4s-1.1-2.4-2.4-2.4-2.4,1.1-2.4,2.4,1.1,2.4,2.4,2.4Z",
    style: {
      fill: "#a6cee8",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,44.3c1.1,0,2-.9,2-2s-.9-2-2-2-2,.9-2,2,.9,2,2,2Z",
    style: {
      fill: "#a6cee8",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5,47.9c1,0,1.9-.8,1.9-1.9s-.8-1.9-1.9-1.9-1.9.8-1.9,1.9.8,1.9,1.9,1.9Z",
    style: {
      fill: "#a6cee8",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1,43.3c1.4,0,2.6-1.2,2.6-2.6s-1.2-2.6-2.6-2.6-2.6,1.2-2.6,2.6,1.2,2.6,2.6,2.6Z",
    style: {
      fill: "#a6cee8",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,23.5c1,0,1.7-.8,1.7-1.7s-.8-1.7-1.7-1.7-1.7.8-1.7,1.7.8,1.7,1.7,1.7Z",
    style: {
      fill: "#a6cee8",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7,31.3c1,0,1.8-.8,1.8-1.8s-.8-1.8-1.8-1.8-1.8.8-1.8,1.8.8,1.8,1.8,1.8Z",
    style: {
      fill: "#a6cee8",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3,41.6h2.1l2.7,7.3v-7.3h1.8v10.6h-2.1l-2.7-7.3v7.3h-1.8v-10.6h0Z",
    style: {
      fill: "#008d58",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9,47.6v4.5h-1.8v-1.2c-.3.5-.5.8-.8,1.1-.3.2-.7.3-1.1.3s-1.1-.3-1.4-.7c-.4-.5-.6-1.1-.6-1.9s.2-1.6.7-2c.5-.5,1.2-.7,2.1-.7h1.1v-.2c0-.4-.1-.7-.4-.9-.2-.2-.6-.3-1-.3s-.7,0-1.1.2c-.3.1-.6.3-.9.5v-1.9c.4-.2.8-.3,1.2-.3.4,0,.8-.1,1.2-.1,1,0,1.7.3,2.2.9.5.6.7,1.5.7,2.7ZM61.2,48.6c-.4,0-.7.1-.8.3-.2.2-.3.5-.3.8s0,.6.2.8c.2.2.4.3.6.3s.6-.2.9-.5c.2-.4.4-.8.4-1.3v-.3h-.9Z",
    style: {
      fill: "#008d58",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.9,44.4v2.1c-.3-.3-.5-.4-.7-.5-.3-.1-.5-.2-.8-.2-.5,0-.9.2-1.2.6-.3.4-.4,1-.4,1.7s.2,1.3.4,1.7c.3.4.7.6,1.2.6s.6,0,.8-.2c.3-.1.5-.3.7-.5v2.1c-.3.2-.6.3-.9.3-.3,0-.6.1-.9.1-1,0-1.8-.4-2.3-1.1-.6-.7-.9-1.8-.9-3s.3-2.3.9-3c.6-.7,1.4-1.1,2.3-1.1s.6,0,.9.1c.3.1.6.2.9.3h0Z",
    style: {
      fill: "#008d58",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77,47.3v4.8h-1.8v-5.1c0-.3,0-.5-.1-.6,0-.2-.2-.3-.3-.4-.1-.1-.3-.2-.4-.2-.4,0-.7.2-.9.6-.2.4-.3,1-.3,1.7v3.9h-1.8v-11h1.8v4.3c.3-.5.6-.8.9-1,.3-.2.6-.3,1-.3.7,0,1.1.3,1.5.9.4.6.5,1.4.5,2.4h-.1Z",
    style: {
      fill: "#008d58",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4,45.4c.3-.5.5-.8.8-1,.3-.2.7-.3,1-.3.7,0,1.2.4,1.7,1.2.5.8.7,1.8.7,3s-.2,2.2-.7,3c-.5.8-1,1.2-1.7,1.2s-.7-.1-1-.3c-.3-.2-.6-.6-.8-1v1.2h-1.8v-11h1.8v4.3h0ZM81.6,50.5c.4,0,.7-.2.9-.6.2-.4.3-1,.3-1.7s-.1-1.3-.3-1.7c-.2-.4-.5-.6-.9-.6s-.7.2-.9.6c-.2.4-.3,1-.3,1.7s.1,1.3.3,1.7c.2.4.5.6.9.6Z",
    style: {
      fill: "#008d58",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1,47.6v4.5h-1.8v-1.2c-.3.5-.5.8-.8,1.1-.3.2-.7.3-1.1.3s-1.1-.3-1.4-.7c-.4-.5-.6-1.1-.6-1.9s.2-1.6.7-2c.5-.5,1.2-.7,2.1-.7h1.1v-.2c0-.4-.1-.7-.4-.9-.2-.2-.6-.3-1-.3s-.7,0-1.1.2c-.3.1-.6.3-.9.5v-1.9c.4-.2.8-.3,1.2-.3.4,0,.8-.1,1.2-.1,1,0,1.7.3,2.2.9.5.6.7,1.5.7,2.7ZM88.4,48.6c-.4,0-.7.1-.8.3-.2.2-.3.5-.3.8s0,.6.2.8c.2.2.4.3.6.3s.6-.2.9-.5c.2-.4.4-.8.4-1.3v-.3h-.9Z",
    style: {
      fill: "#008d58",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.9,46.4c-.2-.1-.3-.2-.5-.3-.2,0-.3,0-.5,0-.5,0-.8.2-1.1.6-.3.4-.4,1-.4,1.8v3.7h-1.8v-7.9h1.8v1.3c.2-.5.5-.9.8-1.1.3-.3.7-.4,1.1-.4s.1,0,.2,0h.3v2.3h0Z",
    style: {
      fill: "#008d58",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,44.4v1.9c-.4-.2-.8-.4-1.1-.5-.4-.1-.7-.2-1-.2s-.6,0-.8.2c-.2.1-.3.3-.3.6s0,.4.2.5c.1.1.4.2.7.3h.3c.9.3,1.5.5,1.8.9s.5,1,.5,1.8-.2,1.5-.7,1.9c-.5.5-1.1.7-1.9.7s-.8,0-1.1-.1c-.4-.1-.8-.2-1.2-.4v-1.9c.4.3.7.4,1.1.6.4.1.8.2,1.1.2s.6,0,.8-.2c.2-.2.3-.4.3-.6s0-.4-.2-.5c-.2-.1-.4-.2-.7-.3h-.3c-.8-.2-1.3-.5-1.7-.9-.3-.4-.5-1-.5-1.7s.2-1.5.6-1.9c.4-.4,1-.6,1.8-.6s.7,0,1,.1c.4.1.8.2,1.2.4l.2-.2Z",
    style: {
      fill: "#008d58",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.2,44.4v2.1c-.3-.3-.5-.4-.7-.5-.3-.1-.5-.2-.8-.2-.5,0-.9.2-1.2.6-.3.4-.4,1-.4,1.7s.2,1.3.4,1.7c.3.4.7.6,1.2.6s.6,0,.8-.2c.3-.1.5-.3.7-.5v2.1c-.3.2-.6.3-.9.3-.3,0-.6.1-.9.1-1,0-1.8-.4-2.3-1.1-.6-.7-.9-1.8-.9-3s.3-2.3.9-3c.6-.7,1.4-1.1,2.3-1.1s.6,0,.9.1c.3.1.6.2.9.3h0Z",
    style: {
      fill: "#008d58",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.3,47.3v4.8h-1.8v-5.1c0-.3,0-.5-.1-.6,0-.2-.2-.3-.3-.4-.1-.1-.3-.2-.4-.2-.4,0-.7.2-.9.6-.2.4-.3,1-.3,1.7v3.9h-1.8v-11h1.8v4.3c.3-.5.6-.8.9-1,.3-.2.6-.3,1-.3.7,0,1.1.3,1.5.9.4.6.5,1.4.5,2.4h-.1Z",
    style: {
      fill: "#008d58",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.1,47.6v4.5h-1.8v-1.2c-.3.5-.5.8-.8,1.1-.3.2-.7.3-1.1.3s-1.1-.3-1.4-.7c-.4-.5-.6-1.1-.6-1.9s.2-1.6.7-2c.5-.5,1.2-.7,2.1-.7h1.1v-.2c0-.4-.1-.7-.4-.9-.2-.2-.6-.3-1-.3s-.7,0-1.1.2c-.3.1-.6.3-.9.5v-1.9c.4-.2.8-.3,1.2-.3.4,0,.8-.1,1.2-.1,1,0,1.7.3,2.2.9.5.6.7,1.5.7,2.7ZM119.4,48.6c-.4,0-.7.1-.8.3-.2.2-.3.5-.3.8s0,.6.2.8c.2.2.4.3.6.3s.6-.2.9-.5c.2-.4.4-.8.4-1.3v-.3h-.9Z",
    style: {
      fill: "#008d58",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.4,41.1v1.7h-1c-.3,0-.4,0-.5.2-.1.2-.2.4-.2.7v.6h1.5v1.8h-1.5v6.1h-1.8v-6.1h-.9v-1.8h.9v-.6c0-.9.2-1.5.5-1.9.4-.4.9-.6,1.6-.6h1.4,0Z",
    style: {
      fill: "#008d58",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.1,42v2.2h1.8v1.8h-1.8v3.3c0,.4,0,.6.2.8.1.2.3.2.6.2h.9v1.8h-1.5c-.7,0-1.2-.2-1.5-.6-.3-.4-.5-1.1-.5-2.1v-3.3h-.9v-1.8h.9v-2.2h1.8Z",
    style: {
      fill: "#008d58",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.3,44.4v1.9c-.4-.2-.8-.4-1.1-.5-.4-.1-.7-.2-1-.2s-.6,0-.8.2c-.2.1-.3.3-.3.6s0,.4.2.5c.1.1.4.2.7.3h.3c.9.3,1.5.5,1.8.9.3.4.5,1,.5,1.8s-.2,1.5-.7,1.9c-.5.5-1.1.7-1.9.7s-.8,0-1.1-.1c-.4-.1-.8-.2-1.2-.4v-1.9c.4.3.7.4,1.1.6.4.1.8.2,1.1.2s.6,0,.8-.2c.2-.2.3-.4.3-.6s0-.4-.2-.5c-.2-.1-.4-.2-.7-.3h-.3c-.8-.2-1.3-.5-1.7-.9-.3-.4-.5-1-.5-1.7s.2-1.5.6-1.9c.4-.4,1-.6,1.8-.6s.7,0,1,.1c.4.1.8.2,1.2.4l.2-.2Z",
    style: {
      fill: "#008d58",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.8,51v4.2h-1.8v-11h1.8v1.2c.3-.5.5-.8.8-1,.3-.2.7-.3,1-.3.7,0,1.2.4,1.7,1.2.5.8.7,1.8.7,3s-.2,2.2-.7,3c-.5.8-1,1.2-1.7,1.2s-.7-.1-1-.3c-.3-.2-.6-.6-.8-1h0ZM142,45.9c-.4,0-.7.2-.9.6-.2.4-.3,1-.3,1.7s.1,1.3.3,1.7.5.6.9.6.7-.2.9-.6.3-1,.3-1.7-.1-1.3-.3-1.7c-.2-.4-.5-.6-.9-.6Z",
    style: {
      fill: "#008d58",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.4,46.4c-.2-.1-.3-.2-.5-.3-.2,0-.3,0-.5,0-.5,0-.8.2-1.1.6-.3.4-.4,1-.4,1.8v3.7h-1.8v-7.9h1.8v1.3c.2-.5.5-.9.8-1.1.3-.3.7-.4,1.1-.4s.1,0,.2,0h.3v2.3h0Z",
    style: {
      fill: "#008d58",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.8,48.2v.7h-4.1c0,.6.2,1.1.5,1.3.3.3.6.5,1.1.5s.8-.1,1.2-.3c.4-.2.8-.4,1.2-.7v2c-.4.2-.8.4-1.3.5-.4.1-.9.2-1.3.2-1,0-1.8-.4-2.3-1.1-.6-.8-.8-1.8-.8-3.1s.3-2.3.8-3c.6-.8,1.3-1.1,2.2-1.1s1.6.4,2.1,1.1.8,1.8.8,3h0ZM154.9,47.3c0-.5-.1-.9-.3-1.2-.2-.3-.5-.5-.8-.5s-.6.2-.8.4c-.2.3-.4.7-.4,1.2h2.3Z",
    style: {
      fill: "#008d58",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.1,41.1h1.8v2.1h-1.8v-2.1ZM158.1,44.2h1.8v7.9h-1.8v-7.9Z",
    style: {
      fill: "#008d58",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.9,44.4v1.9c-.4-.2-.8-.4-1.1-.5s-.7-.2-1-.2-.6,0-.8.2c-.2.1-.3.3-.3.6s0,.4.2.5c.1.1.4.2.7.3h.3c.9.3,1.5.5,1.8.9s.5,1,.5,1.8-.2,1.5-.7,1.9c-.5.4-1.1.7-1.9.7s-.8,0-1.1-.1c-.4-.1-.8-.2-1.2-.4v-1.9c.4.3.7.4,1.1.6.4.1.8.2,1.1.2s.6,0,.8-.2c.2-.2.3-.4.3-.6s0-.4-.2-.5c-.2-.1-.4-.2-.7-.3h-.3c-.8-.2-1.3-.5-1.7-.9-.3-.4-.5-1-.5-1.7s.2-1.5.6-1.9,1-.6,1.8-.6.7,0,1,.1c.4,0,.8.2,1.2.4l.2-.2Z",
    style: {
      fill: "#008d58",
      strokeWidth: 0
    }
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLogoBrandCompetition);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo-brand-competition.3eb2852663f7e60bbee302936ce730d7.svg";